<template>
  <AppAdsense
    ad-class="google-ad--aside"
    ad-style="display:block"
    ad-client="ca-pub-9118328092882671"
    ad-slot="8448157460"
  />
</template>
